import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useHireDispatcher = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const { ninNumber } = useParams();

    const onHireDispatcherError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while creating drivers account.',
        );
    };

    const onHireDispatcherSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message || 'Driver hired successfully');
        callbackFn();
    };

    const hireDispatcher = (data: any, callbackFn: () => void) => {
        const formData = new FormData();

        formData.append('startDate', data.startDate);
        formData.append('nin', ninNumber ?? '');
        formData.append('phoneNumber', data.phoneNumber);
        formData.append('address', data.address);
        // formData.append('assignedVehicle', data.assignedVehicle);
        // formData.append('plateNumber', data.plateNumber);
        formData.append('employmentType', data.employmentType);


        if (data.profilePicture && data.profilePicture.length > 0 && data.profilePicture[0] instanceof File) {
            formData.append('profilePicture', data.profilePicture[0], data.profilePicture[0].name);
        } else {
            console.warn('No valid profilePicture provided');
        }

        const url: HttpConfig = {
            url: 'api/v1/dispatchers/hire',
            method: 'post',
            data: formData
        };

        request(url, onHireDispatcherSuccess(callbackFn), setLoading, onHireDispatcherError);
    };

    return { hireDispatcher, loading };
};

export default useHireDispatcher;
